<template>
  <fragment>
    <div class="row" v-if="entity">
      <div class="col-lg-12 col-xl-3">
        <div class="card m-b-30">
          <div class="card-body">
            <div
              class="nav flex-column nav-pills"
              id="v-pills-product-tab"
              role="tablist"
              aria-orientation="vertical"
            >
              <a
                class="nav-link mb-2 active"
                id="v-pills-general-tab"
                data-toggle="pill"
                href="#v-pills-general"
                role="tab"
                aria-controls="v-pills-general"
                aria-selected="true"
              >
                <i class="feather icon-info mr-2"></i>Comunicazione
              </a>
              <a
                class="nav-link mb-2"
                id="v-pills-attachments-tab"
                data-toggle="pill"
                href="#v-pills-attachments"
                role="tab"
                aria-controls="v-pills-note"
                aria-selected="false"
              >
                <i class="feather icon-download mr-2"></i>Allegati
              </a>
              <a
                class="nav-link mb-2"
                id="v-pills-preview-tab"
                data-toggle="pill"
                href="#v-pills-preview"
                role="tab"
                aria-controls="v-pills-preview"
                aria-selected="false"
                @click="refreshPreview"
              >
                <i class="feather icon-eye mr-2"></i>Anteprima comunicazione
              </a>
              <a
                class="nav-link mb-2"
                id="v-pills-execution-tab"
                data-toggle="pill"
                href="#v-pills-execution"
                role="tab"
                aria-controls="v-pills-execution"
                aria-selected="false"
              > 
                <i class="feather icon-play mr-2"></i>Anteprima clienti
              </a>

              <a v-if="entity.status!='None'"
                class="nav-link mb-2"
                id="v-pills-stats-tab"
                data-toggle="pill"
                href="#v-pills-stats"
                role="tab"
                aria-controls="v-pills-stats"
                aria-selected="false"
                 @click="statsNewsletter"
              >
                <i class="feather icon-pie-chart mr-2"></i>Statistiche
              </a>
            </div>
          </div>
        </div>
      </div>

      <div class="col-lg-12 col-xl-9">
        <div class="card mb-3">
          <div class="card-body">
        
<span class="badge badge-success p-2 mr-3" v-if="entity.status == 'Sent'">Comunicazione inviata</span>
<span class="badge badge-info p-2 mr-3" v-if="entity.status == 'Sending'">Invio in corso</span>
<span class="badge badge-warning p-2 mr-3" v-if="entity.status == 'Paused'">Invio in pausa</span>
<span class="badge badge-danger p-2 mr-3" v-if="entity.status == 'Cancelled'">Invio annullato</span>

             <button
              class="btn btn-primary-rgba  mr-3"
              v-if="
                $store.getters.isInRole('newsletter-send') &&
                entity.status == 'Sending'
              "
             @click="pauseNewsletter(false)"
            >
              <i class="feather icon-pause"></i>
              Metti in pausa l'invio comunicazione
            </button>
            <button
              class="btn btn-primary-rgba mr-3"
              v-if="
                $store.getters.isInRole('newsletter-send') &&
                entity.status == 'Paused'
              "
             @click="playNewsletter(false)"
            >
              <i class="feather icon-play"></i>
              Riavvia invio comunicazione
            </button>
                 <button
              class="btn btn-danger-rgba  mr-3"
              v-if="
                $store.getters.isInRole('newsletter-send') &&
                (entity.status == 'Paused' || entity.status == 'Sending')
              "
             @click="stopNewsletter(false)"
            >
              <i class="feather icon-trash"></i>
              Annulla invio comunicazione
            </button>
            <button
              class="btn btn-primary-rgba mr-3"
              v-if="
                $store.getters.isInRole('newsletter-send') &&
               ( entity.status == 'None' || entity.status == 'Cancelled' )
              "
             @click="sendNewsletter(false)"
            >
              <i class="feather icon-send"></i>
              Invia comunicazione
            </button>
             <button
              class="btn btn-warning-rgba"
              v-if="
                $store.getters.isInRole('newsletter-send') &&
                 ( entity.status == 'None' || entity.status == 'Cancelled' )
              "
             @click="sendNewsletter(true)"
            >
              <i class="feather icon-send"></i>
              Invia comunicazione di test
            </button>
<div id="chart">
      

       
      </div>


          </div>
        </div>
       
        <div class="card m-b-30">
          <div class="card-body">
            <div class="tab-content" id="v-pills-product-tabContent">
              <div
                class="tab-pane fade show active"
                id="v-pills-general"
                role="tabpanel"
                aria-labelledby="v-pills-general-tab"
              >
                <form @submit.prevent="save" v-if="entity">
                  <div class="row">
                    <div class="col-12">
                      <div class="form-group">
                        <label class="col-form-label" for="descrizione"
                          >Modello</label
                        >
                        <v-select
                          placeholder="Modello"
                          v-model="entity.template"
                          :disabled="isReadOnly"
                          :options="templates"
                          label="messageCode"
                        >
                          <template slot="no-options">Elenco modelli</template>
                          <template slot="option" slot-scope="option">
                            <div
                              class="d-center"
                              v-if="option != null && option.type != null"
                            >
                              {{ option.messageCode }}
                            </div>
                          </template>
                          <template slot="selected-option" slot-scope="option">
                            <div
                              class="d-center"
                              v-if="option != null && option.type != null"
                            >
                              {{ option.messageCode }}
                            </div>
                          </template>
                        </v-select>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="form-group">
                        <label class="col-form-label" for="descrizione"
                          >Oggetto</label
                        >
                        <input
                          :disabled="isReadOnly"
                          type="text"
                          class="form-control required"
                          id="descrizione"
                          name="descrizione"
                          placeholder="Oggetto comunicazione"
                          v-model="entity.subject"
                        />
                      </div>
                    </div>

                    <div class="col-10">
                      <label class="col-form-label">Tag di ricerca</label>
                      <taglist
                        :readOnly="isReadOnly"
                        v-model="entity.configuration.tags"
                        :exclude="['allegati']"
                      ></taglist>
                    </div>

                    <div class="col-2">
                      <label class="col-form-label">Operatore</label>
                      <select
                        class="form-control"
                        v-model="entity.configuration.operator"
                        :disabled="isReadOnly"
                      >
                        <option value="AND">AND</option>
                        <option value="OR">OR</option>
                      </select>
                    </div>

                    <div class="col-12">
                      <label class="col-form-label" for="descrizione"
                        >Elenco destinatari di test</label
                      >
                      <input
                        type="text"
                        class="form-control required"
                        id="descrizione"
                        name="descrizione"
                        placeholder="Elenco email separate da ;"
                        v-model="entity.testEmails"
                      />
                    </div>

                    <div class="col-12">
                      <div class="form-group">
                        <label class="col-form-label" for="type"
                          >Contenuto</label
                        >

                        <editor
                          :disabled="isReadOnly"
                          :api-key="tinyKey"
                          :init="{
                             convert_urls: false,
                             remove_script_host: false,
                            height: 500,
                            menubar: false,
                            plugins: [
                              'advlist autolink lists link image charmap print preview anchor',
                              'searchreplace visualblocks code fullscreen',
                              'insertdatetime media table paste code help wordcount',
                            ],
                            toolbar:
                              'undo redo | formatselect | bold italic backcolor | \
           alignleft aligncenter alignright alignjustify | \
           bullist numlist outdent indent | removeformat | code',
                          }"
                          v-model="entity.body"
                          model-events="change paste"
                        ></editor>
                      </div>
                    </div>
                  </div>

                  <div class="form-group mt-3">
                    <button
                      type="button"
                      class="btn btn-xs btn-primary-rgba mr-2"
                      v-on:click="save"
                      v-if="!isReadOnly"
                    >
                      Salva
                      <font-awesome-icon
                        :icon="['far', 'save']"
                      ></font-awesome-icon>
                    </button>
                    <button
                      type="button"
                      class="btn btn-xs btn-danger-rgba mr-2"
                      v-on:click="cancel"
                    >
                      Annulla
                      <font-awesome-icon
                        :icon="['far', 'times-circle']"
                      ></font-awesome-icon>
                    </button>
                  </div>
                </form>
              </div>
              <div
                class="tab-pane fade"
                id="v-pills-attachments"
                role="tabpanel"
                aria-labelledby="v-pills-attachments-tab"
              >
                <attachments
                  entityType="newsletter"
                  :value="entity.newsletterId"
                />
              </div>
               <div
                class="tab-pane fade"
                id="v-pills-stats"
                role="tabpanel"
                aria-labelledby="v-pills-stats-tab"
              >
              <div class="row">
<div class="col-6">
                  <apexchart ref="realtimeChart" type="radialBar" height="350" :options="chartOptions" :series="series" ></apexchart>

</div>
<div class="col-6">
  <table class="table mb-2">
    <tbody>
      <tr v-for="s in stats.stats" >
<td :style="'color:'+s.color">
<i class="fa fa fa-circle"></i> {{s.description}}

</td>
<td :style="'color:'+s.color">
{{s.total}} 
({{s.percentage}}%)
</td>

      </tr>
      </tbody>
    </table>

<button class="btn  btn-success-rgba btn-sm" @click="report"><i class="fa fa-file-excel-o"></i> Scarica report invio</button>
</div>

              </div>
              </div>
              <div
                class="tab-pane fade"
                id="v-pills-preview"
                role="tabpanel"
                aria-labelledby="v-pills-preview-tab"
              >
                <iframe
                  frameborder="0"
                  name="iframepreview"
                  id="iframepreview"
                  class="b-0 w-100"
                />
              </div>
              <div
                class="tab-pane fade"
                id="v-pills-execution"
                role="tabpanel"
                aria-labelledby="v-pills-execution-tab"
              >
                <div class="row">
                  <div class="col-12">
                    <button
                      type="button"
                      class="btn btn-block btn-info-rgba m-1 mb-5"
                      v-on:click="loaddata"
                    >
                      Elenco destinatari
                    </button>

                    <table
                      ref="table"
                      id="list-company-table"
                      class="table w-100"
                    ></table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <a ref="attachmentA"></a>
  </fragment>
</template>

<script>
import * as srcDoc from "srcdoc-polyfill";
import Editor from "@tinymce/tinymce-vue";
import axios from "axios";
import { Chrome } from "vue-color";
import { Slider } from "vue-color";
import Breadcrumb from '../../components/Breadcrumb.vue';
export default {
  data() {
    return {
      entity: null,
      colors: "#FFFFFF",
      templates: [],
      stats: { status:'None', stats:[]},
      series:[],
      valueseries:[],
      labels:[],
      colors:[],
     chartOptions: {
       legend: {
              show: false,
              floating: true,
              fontSize: '16px',
              position: 'left',
              offsetX: 160,
              offsetY: 15,
              labels: {
                useSeriesColors: true,
              },
              markers: {
                size: 0
              },
              formatter: function(seriesName, opts) {
                return seriesName + ":  " + opts.w.globals.series[opts.seriesIndex]
              },
              itemMargin: {
                vertical: 3
              }
            }
     ,
       labels:[''],
       colors:['#FFFFFF'],
            chart: {
              height: 350,
              type: 'radialBar',
            },
            plotOptions: {
              radialBar: {
               
                dataLabels: {
                  name: {
                    fontSize: '22px',
                  },
                  value: {
                    fontSize: '16px',
                  },
                  total: {
                    show: true,
                    label: 'Totali',
                    formatter: function (w) {
                   
                    }
                  }
                }
              }
            }
     }
    }
  },
  computed: {
    tinyKey: function () {
      return window.SETTINGS.TinyApiKey;
    },
    isReadOnly: function () {
      var status = (this.entity && this.entity.status) || "undefined";
      return (
        status != "None" && status!="Cancelled" && !this.$store.getters.isInRole("newsletter-edit")
      );
    },
  },
  components: {
    Editor,
    "chrome-picker": Chrome,
    Breadcrumb,
  },
  name: "NewsletterSave",
  beforeMount() {
    var me = this;
    axios.get("newsletter/templates").then((response) => {
      me.templates = response.data;
    });
    axios.get("newsletter/" + me.$route.params.id).then((response) => {
      me.entity = response.data;

      if (me.entity.subject && me.entity.subject != "") {
        me.$store.state.breadCrump.title = me.entity.subject;
      }
      me.statsNewsletter();
    });
    var me = this;
    console.log(me.series)
    this.chartOptions.plotOptions.radialBar.dataLabels.total.formatter = function(){
   // By default this function returns the average of all series. The below is just an example to show the use of custom formatter function
                      var retval = 0;
                      for(var i=0; i<me.valueseries.length;i++){
                        
retval+=me.valueseries[i];

                      }
                      return retval;

    }
  },
  methods: {
    refreshPreview: function () {
      var me = this;
      axios
        .post(`newsletter/fastpreview/${me.entity.template.messageCode}`, {
          body: me.entity.body,
        })
        .then((response) => {
          console.log(response);
          setTimeout(function () {
            $("#iframepreview").attr("srcdoc", response.data);
            setTimeout(function () {
              $("#iframepreview")[0].style.height =
                $("#iframepreview")[0].contentWindow.document.documentElement
                  .scrollHeight + "px";
            }, 200);
          }, 200);
        });
    },

    loaddata: function () {
      var me = this;
      if ($.fn.DataTable.isDataTable("#list-company-table")) {
        $("#list-company-table").DataTable().destroy();
      }

      var $table = $("#list-company-table").DataTable({
        searching: false,
        ordering: false,
        processing: true,
        serverSide: true,
        ajax: {
          url: window.SETTINGS.apiUrl + "/company/list",
          type: "POST",
          data: function (d) {
            d.search.value = "";
            d.tagOperator = me.entity.configuration.operator;
            d.filters = [
              {
                key: "tags",
                value: JSON.stringify(me.entity.configuration.tags),
              },
            ];
           

            return JSON.stringify(d);
          },

          beforeSend: function (request) {
            request.setRequestHeader(
              "Authorization",
              "Bearer " + me.$store.state.user.token
            );
            request.setRequestHeader("Content-Type", "application/json");
          },
        },

        columns: [
          {
            data: "companyId",
            name: "companyId",
            title: "Codice",
            render: function (data, type, row, meta) {
              return row.internalCode;
            },
          },
          {
            data: "companyId",
            name: "companyId",
            title: "Azienda",
            render: function (data, type, row, meta) {
              return row.name;
            },
          },
        ],
      });
    },
    sendNewsletter: function (test) {
      var me = this;
      me.$swal({
        title: ``,
        html: `Sicuri di voler inviare la comunicazione<br/><strong>"${me.entity.subject}"</strong>?<br/><br/><i>Tutte le modifiche effettuate verranno salvate prima dell'invio</i>`,
        type: "question",
        showCancelButton: true,
        confirmButtonClass: "btn-warning-rgba",
        confirmButtonText: "Procedi",
        cancelButtonText: "Annulla",
      }).then(function (isconfirm) {
        if (isconfirm.value) {
          me.entity.messageTemplateId = me.entity.template.messageTemplateId;
          axios.post("newsletter", me.entity).then((response) => {
            axios
              .post("newsletter/send/" + me.entity.newsletterId+"?test="+test)
              .then((response) => {
                me.$router.go();
              });
          });
        }
      });
    },
     pauseNewsletter: function (test) {
      var me = this;
      me.$swal({
        title: ``,
        html: `Sicuri di voler mettere in pausa l'invio della comunicazione<br/><strong>"${me.entity.subject}"</strong>?`,
        type: "question",
        showCancelButton: true,
        confirmButtonClass: "btn-warning-rgba",
        confirmButtonText: "Procedi",
        cancelButtonText: "Annulla",
      }).then(function (isconfirm) {
        if (isconfirm.value) {
         
         
            axios
              .post("newsletter/pause/" + me.entity.newsletterId+"?test="+test)
              .then((response) => {
                me.$router.go();
              });
         
        }
      });
      
    },
     playNewsletter: function (test) {
      var me = this;
      me.$swal({
        title: ``,
        html: `Sicuri di voler rimettere in invio la comunicazione<br/><strong>"${me.entity.subject}"</strong>?`,
        type: "question",
        showCancelButton: true,
        confirmButtonClass: "btn-warning-rgba",
        confirmButtonText: "Procedi",
        cancelButtonText: "Annulla",
      }).then(function (isconfirm) {
        if (isconfirm.value) {
         
         
            axios
              .post("newsletter/play/" + me.entity.newsletterId+"?test="+test)
              .then((response) => {
                me.$router.go();
              });
         
        }
      });
      
    },
     stopNewsletter: function () {
      var me = this;
      me.$swal({
        title: ``,
        html: `Sicuri di voler annullare l'invio della comunicazione<br/><strong>"${me.entity.subject}"</strong>?`,
        type: "question",
        showCancelButton: true,
        confirmButtonClass: "btn-warning-rgba",
        confirmButtonText: "Procedi",
        cancelButtonText: "Annulla",
      }).then(function (isconfirm) {
        if (isconfirm.value) {
         
         
            axios
              .post("newsletter/stop/" + me.entity.newsletterId)
              .then((response) => {
                me.$router.go();
              });
         
        }
      });
      
    },

     statsNewsletter: function () {
      var me = this;
      
            axios
              .get("newsletter/stats/" + me.entity.newsletterId)
              .then((response) => {
                me.stats = response.data;
                me.series = [];
                me.valueseries= [];
                me.chartOptions.labels = [];
                me.chartOptions.colors = [];
                var total = 0;
                for(var i = 0; i< me.stats.stats.length;i++ ){
var s = me.stats.stats[i];
total+= s.total;
                }
                for(var i = 0; i< me.stats.stats.length;i++ ){
                    var s = me.stats.stats[i];
                    var percentage = parseFloat((100*s.total/total).toFixed(2))
                    s.percentage = percentage
                    me.series.push(percentage);
                    me.valueseries.push(s.total);
                    me.chartOptions.labels.push(s.description);
                    me.chartOptions.colors.push(s.color);

                }

me.$refs.realtimeChart.refresh();
if(me.stats.status == 'Sending') {
setTimeout(me.statsNewsletter,3000);

}
              });
    },
    cancel() {
      this.$router.push({
        name: "route-newsletter-list",

        replace: true,
      });
    },
     report: function () {
      var me = this;
      var url = "";
var o = `${this.$options.filters.slugify(this.entity.subject)}.xlsx`;
      axios
        .get(
          `newsletter/export/${me.entity.newsletterId}`,
          { responseType: "blob" }
        )
        .then(function (result) {
          var blob = new Blob([result.data], {
            type: result.headers["content-type"],
          });
        
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            // for IE
            window.navigator.msSaveOrOpenBlob(blob, o);
          } else {
            me.$refs.attachmentA.href = URL.createObjectURL(blob);
            me.$refs.attachmentA.download = o;
            me.$refs.attachmentA.click();
          }
        });
    },
    save() {
      var me = this;
      me.entity.messageTemplateId = me.entity.template.messageTemplateId;
      axios.post("newsletter", this.entity).then((response) => {
        if (me.$route.params.id != me.entity.newsletterId) {
          me.$router.push({
            name: "route-newsletter-edit",
            params: { id: me.entity.newsletterId },
            replace: true,
          });
        }
        axios.get("newsletter/" + me.entity.newsletterId).then((response) => {
          me.entity = response.data;

          if (me.entity.subject && me.entity.subject != "") {
            me.$store.state.breadCrump.title = me.entity.subject;
          }
        });
        me.$swal({
          title: "Salvataggio avvenuto con successo",
          text: "",
          type: "success",
          showCancelButton: false,
          toast: true,
          timer: 2000,
          showConfirmButton: false,
          position: "bottom-top",
        });
      });
    },
  },
};
</script>
